import {Chip, Typography, useTheme} from '@mui/material';

import {orangeColors} from '../../layouts/theme/designSystem';

interface Props {
  name?: string;
  onDelete: (index: number) => void;
}

export const EmpionSkillChip = ({name, onDelete}: Props) => {
  const theme = useTheme();

  return (
    <Chip
      label={<Typography variant='body1'>{`${name}`}</Typography>}
      onDelete={onDelete}
      sx={{
        borderRadius: '2px',
        backgroundColor: orangeColors[5],
        padding: '24px',
        [theme.breakpoints.down('sm')]: {
          padding: '8px',
        },
        width: 'fit-content',
        '& .MuiChip-deleteIcon': {
          ml: 1,
          [theme.breakpoints.down('sm')]: {
            ml: 0,
          },
          mr: 0,
        },
      }}
    />
  );
};
